module.exports = __webpack_public_path__ + "media/theme/ico-close-2-01383f82.png";